module.exports = __webpack_public_path__ + "static/avatar-0d4002b82a9bc0ccd6a051ce21c721b7.png";